import {
  ContentBlocks,
  contentBlocksQuery,
} from '@/components/contentBlocks/ContentBlocks'
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import { Box } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticPaths, GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'

const pathsToInclude = ['terms-of-service', 'privacy-policy']

export const getStaticPaths: GetStaticPaths = async () => {
  let paths = pathsToInclude.map(slug => {
    return { params: { slug } }
  })

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = async context => {
  // Return 404 if no slug is passed
  if (!context.params?.slug) {
    return {
      notFound: true,
    }
  }

  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query MyQuery($slug: String) {
        entry(collection: "pages", slug: $slug) {
          title
          id
          ... on Entry_Pages_Default {
            call_to_action
            heading
            id
            intro
            pre_heading
            seo_description
            seo_title
            ${contentBlocksQuery}
          }
        }
      }
    `,
    {
      slug: context.params.slug,
    }
  )

  let notFound = data.entry?.title === undefined

  return {
    props: {
      data: data.entry,
    },
    revalidate: 60,
    notFound,
  }
}

export const Page = ({ data }: any) => {
  return (
    <>
      <NextSeo
        title={data.seo_title ?? data.heading ?? data.title}
        description={data.seo_description ?? data.intro}
      />
      <Hero
        heading={data.heading ?? data.title}
        label={data.pre_heading}
        subheading={data.intro}
      />
      <Box pb={20}>
        <ContentBlocks {...data} />
      </Box>
    </>
  )
}

export default Page
